
import messages from '../../locale/messages';


const validate = values => {

    const errors = {};

    // Empty is allowed (clear special price → return to base).
    if (values.isSpecialPrice !== undefined && values.isSpecialPrice !== null && values.isSpecialPrice !== '') {
        const amount = parseFloat(values.isSpecialPrice, 10);
        if (isNaN(amount) || amount <= 0) {
            errors.isSpecialPrice = messages.specialpriceInvalid;
        }
    }

    return errors;
}

export default validate;
